import React from 'react';
import scheme from '../../static/js/scheme';
import Locker from './locker';
import './index.scss';
import Base from '../../base';

const List = ({brand, tab, children, show, setShow}) => {
  if (scheme.version) {
    window.AHAPP.invokeNative('actionbarinfo', {
      title: '成都车展',
      addmenulist: [],
      success: Base.appSetting,
    });
  }
  return (
    <>
      <div className="athm-tab">
        <div className="athm-tab__scroll">
          <div className="athm-tab__anchor">
            <a href='#/brand/all' className={(brand && tab === 'all') ? 'athm-tab__item activate' : 'athm-tab__item'}>
              品牌
            </a>
            <a href='#/brand/isEv' className={(brand && tab === 'isEv') ? 'athm-tab__item activate' : 'athm-tab__item'}>
              新能源
            </a>
            {
              Base.levels.map((item, index) => {
                return <a href={`#/level/${index}`} key={index} className={(!brand && parseInt(tab) === index) ? 'athm-tab__item activate' : 'athm-tab__item'}>
                  {item.name}
                </a>
              })
            }
          </div>
        </div>
      </div>
      <div className="athm-content">
          {
            React.Children.map(children, child => child)
          }
      </div>
      {
        brand && brand.id > 0 && 
        <Locker tab={tab} brand={brand} show={show} setShow={setShow} />
      }
    </>
  )
}

export default List;